import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const perfis = [
  { value: 'cliente', label: 'Cliente' },
  { value: 'operador', label: 'Operador' },
  { value: 'admin', label: 'Administrador' },
];

const fusos = [
  'America/Sao_Paulo',
  'America/Manaus',
  'America/Belem',
  'America/Fortaleza',
  'America/Recife',
  'America/Noronha',
];

function exportarLoginsPDF(lista) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>Logins</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>Logins</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} — ${lista.length} login${lista.length !== 1 ? 's' : ''} — Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Nome</th><th>Email</th><th>Login</th><th>Cliente</th><th>Perfil</th><th>Último acesso</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${lista.map(l => `
            <tr>
              <td>${l.nome || '—'}</td>
              <td>${l.email || '—'}</td>
              <td>${l.login || '—'}</td>
              <td>${l.cliente_nome || '—'}</td>
              <td>${l.perfil || '—'}</td>
              <td>${l.ultimo_acesso ? new Date(l.ultimo_acesso).toLocaleString('pt-BR') : '—'}</td>
              <td>${l.ativo ? 'Ativo' : 'Inativo'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarLoginsCSV(lista) {
  const linhas = [
    'Nome,Email,Login,Cliente,Perfil,Último acesso,Status',
    ...lista.map(l => {
      const campos = [l.nome, l.email, l.login, l.cliente_nome, l.perfil, l.ultimo_acesso ? new Date(l.ultimo_acesso).toLocaleString('pt-BR') : '', l.ativo ? 'Ativo' : 'Inativo'];
      return campos.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(',');
    })
  ];
  const blob = new Blob([String.fromCharCode(0xFEFF) + linhas.join(String.fromCharCode(10))], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `logins_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
}

function Logins() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [logins, setLogins] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [targets, setTargets] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [busca, setBusca] = useState('');
  const [buscaCliente, setBuscaCliente] = useState('');
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);
  const [form, setForm] = useState({
    nome: '', email: '', login: '', senha: '', confirmarSenha: '',
    perfil: 'cliente', cliente_id: '', fuso_horario: 'America/Sao_Paulo',
    observacoes: '', targets: []
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarDados(); }, []);

  useEffect(() => {
    if (modalAberto) {
      axios.get(`${API}/targets`, { headers }).then(r => setTargets(r.data)).catch(e => console.error(e));
      axios.get(`${API}/clientes`, { headers }).then(r => setClientes(r.data)).catch(e => console.error(e));
    }
  }, [modalAberto]);

  const carregarDados = async () => {
    try {
      const loginsRes = await axios.get(`${API}/logins`, { headers });
      setLogins(loginsRes.data);
    } catch (err) { console.error(err); }
  };

  const abrirNovo = () => {
    setEditando(null);
    setBuscaCliente('');
    setForm({ nome: '', email: '', login: '', senha: '', confirmarSenha: '', perfil: 'cliente', cliente_id: '', fuso_horario: 'America/Sao_Paulo', observacoes: '', targets: [] });
    setModalAberto(true);
  };

  const abrirEditar = async (login) => {
    setEditando(login);
    const clienteNome = clientes.find(c => c.id === login.cliente_id)?.nome_fantasia || clientes.find(c => c.id === login.cliente_id)?.nome || '';
    setBuscaCliente(clienteNome);
    const targetsRes = await axios.get(`${API}/logins/${login.id}/targets`, { headers });
    setForm({ nome: login.nome, email: login.email, login: login.login || '', senha: '', confirmarSenha: '', perfil: login.perfil, cliente_id: login.cliente_id || '', fuso_horario: login.fuso_horario || 'America/Sao_Paulo', observacoes: login.observacoes || '', targets: targetsRes.data });
    setModalAberto(true);
  };

  const selecionarCliente = (cliente) => {
    setForm(prev => ({ ...prev, cliente_id: cliente.id }));
    setBuscaCliente(cliente.nome_fantasia || cliente.nome);
    setMostrarSugestoes(false);
  };

  const salvar = async () => {
    if (!form.nome || !form.email) { alert('Nome e email são obrigatórios!'); return; }
    if (!editando && !form.senha) { alert('Senha é obrigatória!'); return; }
    if (form.senha && form.senha !== form.confirmarSenha) { alert('Senhas não conferem!'); return; }
    setSalvando(true);
    try {
      const dados = { ...form };
      delete dados.confirmarSenha;
      if (!dados.senha) delete dados.senha;
      if (editando) { await axios.put(`${API}/logins/${editando.id}`, dados, { headers }); }
      else { await axios.post(`${API}/logins`, dados, { headers }); }
      setModalAberto(false);
      carregarDados();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao salvar'); }
    setSalvando(false);
  };

  const deletar = async (id, nome) => {
    if (!window.confirm(`Deseja excluir o login de "${nome}"? Esta ação não pode ser desfeita.`)) return;
    try {
      await axios.delete(`${API}/logins/${id}`, { headers });
      carregarDados();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao excluir'); }
  };

  const inativar = async (id) => {
    if (!window.confirm('Deseja alterar o status deste login?')) return;
    await axios.patch(`${API}/logins/${id}/inativar`, {}, { headers });
    carregarDados();
  };

  const toggleTarget = (id) => {
    setForm(prev => ({ ...prev, targets: prev.targets.includes(id) ? prev.targets.filter(t => t !== id) : [...prev.targets, id] }));
  };

  const clientesFiltrados = clientes.filter(c => c && (c.nome || c.nome_fantasia) && (c.nome_fantasia || c.nome).toLowerCase().includes(buscaCliente.toLowerCase()));
  const loginsFiltrados = logins.filter(l => l.nome.toLowerCase().includes(busca.toLowerCase()) || l.email.toLowerCase().includes(busca.toLowerCase()) || (l.login || '').toLowerCase().includes(busca.toLowerCase()));

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />
      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🔑 Logins</span>
        </div>
        <button onClick={abrirNovo} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>+ Novo Login</button>
      </div>
      <div style={{ marginTop: '60px', padding: '24px' }}>
        <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '12px', alignItems: 'center' }}>
          <input placeholder="🔍 Buscar por nome, email ou login..." value={busca} onChange={e => setBusca(e.target.value)} style={{ flex: 1, padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
          <button onClick={() => exportarLoginsPDF(loginsFiltrados)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' }}>📄 Exportar PDF</button>
          <button onClick={() => exportarLoginsCSV(loginsFiltrados)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' }}>📥 Exportar Excel</button>
        </div>
        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f8f8f8' }}>
              <tr>{['Nome', 'Email', 'Login', 'Cliente', 'Perfil', 'Último acesso', 'Status', 'Ações'].map(h => <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {loginsFiltrados.length === 0 ? (
                <tr><td colSpan="8" style={{ padding: '32px', textAlign: 'center', color: '#999' }}>Nenhum login cadastrado.</td></tr>
              ) : loginsFiltrados.map((l, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }} onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'} onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                  <td style={{ padding: '12px 16px', fontSize: '14px', fontWeight: '500' }}>{l.nome}</td>
                  <td style={{ padding: '12px 16px', fontSize: '13px', color: '#666' }}>{l.email}</td>
                  <td style={{ padding: '12px 16px', fontSize: '13px', fontFamily: 'monospace' }}>{l.login || '—'}</td>
                  <td style={{ padding: '12px 16px', fontSize: '13px', color: '#1D9E75' }}>{l.cliente_nome || '—'}</td>
                  <td style={{ padding: '12px 16px' }}><span style={{ background: l.perfil === 'admin' ? '#E6F1FB' : l.perfil === 'operador' ? '#FAEEDA' : '#E1F5EE', color: l.perfil === 'admin' ? '#185FA5' : l.perfil === 'operador' ? '#633806' : '#0F6E56', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{l.perfil}</span></td>
                  <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666' }}>{l.ultimo_acesso ? new Date(l.ultimo_acesso).toLocaleString('pt-BR') : '—'}</td>
                  <td style={{ padding: '12px 16px' }}><span style={{ background: l.ativo ? '#E1F5EE' : '#FCEBEB', color: l.ativo ? '#0F6E56' : '#A32D2D', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{l.ativo ? '✅ Ativo' : '❌ Inativo'}</span></td>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => abrirEditar(l)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>✏️ Editar</button>
                      <button onClick={() => inativar(l.id)} style={{ background: l.ativo ? '#FCEBEB' : '#E1F5EE', color: l.ativo ? '#A32D2D' : '#0F6E56', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>{l.ativo ? '🚫' : '✅'}</button>
                      <button onClick={() => deletar(l.id, l.nome)} style={{ background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '900px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h2 style={{ margin: 0, fontSize: '18px', color: '#333' }}>🔑 {editando ? 'Editar Login' : 'Novo Login'}</h2>
              <button onClick={() => setModalAberto(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>
            <div style={{ padding: '24px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
              <div>
                <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#666', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Dados do Login</h3>
                {[
                  { label: 'Nome *', key: 'nome', type: 'text', placeholder: 'Nome completo' },
                  { label: 'E-Mail *', key: 'email', type: 'email', placeholder: 'email@exemplo.com' },
                  { label: 'Login', key: 'login', type: 'text', placeholder: 'Login de acesso (opcional)' },
                  { label: editando ? 'Nova Senha (deixe em branco para manter)' : 'Senha *', key: 'senha', type: 'password', placeholder: editando ? 'Deixe em branco para não alterar' : 'Digite a senha' },
                  { label: 'Confirmar Senha', key: 'confirmarSenha', type: 'password', placeholder: 'Confirmar senha' },
                ].map(f => (
                  <div key={f.key} style={{ marginBottom: '14px' }}>
                    <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>{f.label}</label>
                    <input
                      type={f.type}
                      placeholder={f.placeholder}
                      value={form[f.key]}
                      autoComplete={f.key === 'senha' || f.key === 'confirmarSenha' ? 'new-password' : 'off'}
                      onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                      style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }}
                    />
                  </div>
                ))}
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Perfil</label>
                  <select value={form.perfil} onChange={e => setForm(prev => ({ ...prev, perfil: e.target.value }))} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', background: 'white' }}>
                    {perfis.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: '14px', position: 'relative' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Cliente</label>
                  <input type="text" placeholder="Digite para buscar cliente..." value={buscaCliente}
                    onChange={e => { setBuscaCliente(e.target.value); setMostrarSugestoes(true); setForm(prev => ({ ...prev, cliente_id: '' })); }}
                    onFocus={() => setMostrarSugestoes(true)}
                    onBlur={() => setTimeout(() => setMostrarSugestoes(false), 200)}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
                  {mostrarSugestoes && buscaCliente && clientesFiltrados.length > 0 && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100, maxHeight: '200px', overflowY: 'auto' }}>
                      {clientesFiltrados.map((c, i) => (
                        <div key={i} onMouseDown={() => selecionarCliente(c)} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: '14px', borderBottom: '1px solid #f5f5f5' }} onMouseEnter={e => e.currentTarget.style.background = '#E1F5EE'} onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                          👤 {c.nome_fantasia || c.nome}
                        </div>
                      ))}
                    </div>
                  )}
                  {form.cliente_id && <div style={{ fontSize: '11px', color: '#1D9E75', marginTop: '4px' }}>✅ Cliente selecionado</div>}
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Fuso Horário</label>
                  <select value={form.fuso_horario} onChange={e => setForm(prev => ({ ...prev, fuso_horario: e.target.value }))} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', background: 'white' }}>
                    {fusos.map(f => <option key={f} value={f}>{f}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Observações</label>
                  <textarea value={form.observacoes} onChange={e => setForm(prev => ({ ...prev, observacoes: e.target.value }))} placeholder="Observações sobre este login..." rows={3} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }} />
                </div>
              </div>
              <div>
                <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#666', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Targets Visíveis</h3>
                <p style={{ fontSize: '12px', color: '#999', marginBottom: '12px', marginTop: 0 }}>Selecione quais veículos este login pode visualizar</p>
                <div style={{ border: '1px solid #eee', borderRadius: '10px', overflow: 'hidden' }}>
                  <div style={{ background: '#f8f8f8', padding: '10px 14px', display: 'flex', gap: '8px', borderBottom: '1px solid #eee' }}>
                    <button onClick={() => setForm(prev => ({ ...prev, targets: targets.map(t => t.id) }))} style={{ background: '#1D9E75', color: 'white', border: 'none', borderRadius: '6px', padding: '4px 12px', cursor: 'pointer', fontSize: '12px' }}>Selecionar todos</button>
                    <button onClick={() => setForm(prev => ({ ...prev, targets: [] }))} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '6px', padding: '4px 12px', cursor: 'pointer', fontSize: '12px' }}>Limpar</button>
                  </div>
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {targets.length === 0 ? (
                      <div style={{ padding: '24px', textAlign: 'center', color: '#999', fontSize: '13px' }}>⏳ Carregando veículos...</div>
                    ) : targets.map((t, i) => (
                      <div key={i} onClick={() => toggleTarget(t.id)} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 14px', cursor: 'pointer', borderBottom: '1px solid #f5f5f5', background: form.targets.includes(t.id) ? '#E1F5EE' : 'white' }} onMouseEnter={e => { if (!form.targets.includes(t.id)) e.currentTarget.style.background = '#f9f9f9' }} onMouseLeave={e => { e.currentTarget.style.background = form.targets.includes(t.id) ? '#E1F5EE' : 'white' }}>
                        <div style={{ width: '18px', height: '18px', borderRadius: '4px', border: `2px solid ${form.targets.includes(t.id) ? '#1D9E75' : '#ddd'}`, background: form.targets.includes(t.id) ? '#1D9E75' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          {form.targets.includes(t.id) && <span style={{ color: 'white', fontSize: '12px' }}>✓</span>}
                        </div>
                        <span style={{ fontSize: '18px' }}>{t.icone}</span>
                        <div>
                          <div style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>{t.identificador}</div>
                          <div style={{ fontSize: '11px', color: '#666' }}>{t.nome} {t.cliente_nome ? `— ${t.cliente_nome}` : ''}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ padding: '10px 14px', background: '#f8f8f8', fontSize: '12px', color: '#666', borderTop: '1px solid #eee' }}>{form.targets.length} de {targets.length} selecionados</div>
                </div>
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '12px', position: 'sticky', bottom: 0, background: 'white' }}>
              <button onClick={() => setModalAberto(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>{salvando ? '⏳ Salvando...' : '✅ Salvar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Logins;